export default __webpack_public_path__ + "static/media/3.92387252.png";